import { TWebsiteBuilderSectionEntityResizeHandle } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderSectionEntity";
import { WEBSITE_BUILDER_Z_LAYERS } from "pages/secure/facility/websiteBuilder/editor/utility/websiteBuilderZLayers";
import React, { useMemo } from "react";

export type TSectionEntityViewResizeHandlePointerDown = (e: React.PointerEvent, handle: TWebsiteBuilderSectionEntityResizeHandle) => void;

interface ISectionEntityViewResizeHandleProps {
  handle: TWebsiteBuilderSectionEntityResizeHandle;
  viewWidth: number;
  viewHeight: number;
  onPointerDown: TSectionEntityViewResizeHandlePointerDown;
}

export function SectionEntityViewResizeHandle(props: ISectionEntityViewResizeHandleProps) {
  const { handle, viewWidth, viewHeight, onPointerDown } = props;

  const style: React.CSSProperties = useMemo(() => {
    const HANDLE_SIZE = 6;
    const HALF_HANDLE_SIZE = HANDLE_SIZE / 2;

    const defaultStyles: React.CSSProperties = {
      zIndex: WEBSITE_BUILDER_Z_LAYERS.designSpace.sectionEntityOverride,
      width: HANDLE_SIZE,
      height: HANDLE_SIZE,
    };

    switch (handle) {
      case "NorthWest":
        return {
          ...defaultStyles,
          left: -HALF_HANDLE_SIZE,
          top: -HALF_HANDLE_SIZE,
          cursor: "nwse-resize",
        };
      case "North":
        return {
          ...defaultStyles,
          left: viewWidth / 2 - HALF_HANDLE_SIZE,
          top: -HALF_HANDLE_SIZE,
          cursor: "ns-resize",
        };
      case "NorthEast":
        return {
          ...defaultStyles,
          left: viewWidth - HALF_HANDLE_SIZE,
          top: -HALF_HANDLE_SIZE,
          cursor: "nesw-resize",
        };
      case "West":
        return {
          ...defaultStyles,
          left: -HALF_HANDLE_SIZE,
          top: viewHeight / 2 - HALF_HANDLE_SIZE,
          cursor: "ew-resize",
        };
      case "East":
        return {
          ...defaultStyles,
          left: viewWidth - HALF_HANDLE_SIZE,
          top: viewHeight / 2 - HALF_HANDLE_SIZE,
          cursor: "ew-resize",
        };
      case "SouthWest":
        return {
          ...defaultStyles,
          left: -HALF_HANDLE_SIZE,
          top: viewHeight - HALF_HANDLE_SIZE,
          cursor: "nesw-resize",
        };
      case "South":
        return {
          ...defaultStyles,
          left: viewWidth / 2 - HALF_HANDLE_SIZE,
          top: viewHeight - HALF_HANDLE_SIZE,
          cursor: "ns-resize",
        };
      case "SouthEast":
        return {
          ...defaultStyles,
          left: viewWidth - HALF_HANDLE_SIZE,
          top: viewHeight - HALF_HANDLE_SIZE,
          cursor: "nwse-resize",
        };
      default:
        return {};
    }
  }, [handle, viewWidth, viewHeight]);

  return (
    <div
      className="website-builder-section-entity-view-resize-handle"
      style={style}
      onPointerDown={e => onPointerDown(e, handle)}
    />
  );
}
